import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizModal, WizCard } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/onlineNotification/startNotification') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('startNotification', record)
        } else {
            record = Session.get('startNotification') || {}
        }
    }
    return record
}

class StartNotification extends WizContainer {

    componentName = 'StartNotification'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/startNotice',
            payload: {
                key: 'startNotice@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId,
                    notDiscarded: 0
                }
            }
        })
    }

    _onBtn = (type, id) => {
        const { processContentId } = this.state.record
        switch (type) {
            case 'send':
                this.jumpPage('push', '/integrationCounseling/manager/onlineNotification/sendNotification', { processContentId })
                break
            case 'look':
                this.jumpPage('push', '/integrationCounseling/manager/onlineNotification/lookNotification', { processContentId, recordId: id })
                break
        }
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmNotice',
                    payload: {
                        key: 'confirmNotice@' + processContentId,
                        apiParams: {
                            tutorContentId: processContentId
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

  _Discard = (id) => {
      WizModal.confirm({
          title: '注意',
          content: '是否确认进行作废操作？',
          onOk: () => {
              this.doAction({
                  path: 'counselingProcess/updateStartNoticeState',
                  payload: {
                      key: 'counselingProcess/updateStartNoticeState',
                      apiParams: {
                          id: id,
                          state: 5
                      }
                  }
              })
          },
        onCancel() {

        }
      })
  }

    propsAndStateOnChange = {
        confirm: this._confirmOnChange.bind(this),
        updateStartNoticeState: this._updateStartNoticeState.bind(this)
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    _updateStartNoticeState(nextProps,nextState) {
        if (nextProps.updateStartNoticeState.code === 1) {
            wizNotice.success('操作成功')
            this._list()
        } else {
            wizNotice.error(nextProps.updateStartNoticeState.msg)
        }
    }

    render() {
        let { list, counselingProcessLoading } = this.props
        let { record } = this.state
        let row = list && list.data && list.data.length ? list.data[0] || {} : {}
        let columns = [{
            title: '执行内容',
            name: 'content',
            dataIndex: 'content'
        }, {
            title: '通知时间',
            name: 'noticeTime',
            dataIndex: 'noticeTime',
            align: 'center'
        }, {
            title: '签收时间',
            name: 'completeTime',
            dataIndex: 'completeTime',
            align: 'center'
        }, {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            align: 'center',
            render: (v) => {
                switch (v) {
                    case 1:
                        return '待下发'
                    case 2:
                        return '待签收'
                    case 3:
                    case 4:
                        return '已签收'
                    case 5:
                        return '已作废'
                    default:
                        return ''
                }
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 220,
            render: (v, r, i) => {
                let { id, state } = r
                return (
                    <WizButton.Group>
                        <WizButton type='link' disabled={state === 1} onClick={() => this._onBtn('look', id)}>
                            {'查看'}
                        </WizButton>
                        <WizButton type='link' disabled={state != 2 } onClick={() => this._Discard(id)}>
                            {'作废'}
                        </WizButton>
                    </WizButton.Group>
                )
            }
        }]

        let tableProps = {
            columns,
            dataSource: list.data || [],
            pagination: false,
            bordered: true
        }

        let disabled = true
        if (row.state === 3) {
            disabled = false
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='启动通知'>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15, width: 120 }}
                        onClick={() => this._onBtn('send')}>
                        {'下发启动通知'}
                    </WizButton>
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId,id } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'startNotice@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmNotice@' + processContentId)
    const updateStartNoticeState = modelUtils.getModelEntity(counselingProcess, 'counselingProcess/updateStartNoticeState')
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        confirm,
        updateStartNoticeState,
        ...loading
    }
}

export default connect(mapStateToProps)(StartNotification)


